export default __webpack_public_path__ + "media/svgs/filter-c9b21da6.svg";